import React from "react";
import {SearchForm} from "./searchForm"
import JournalList from "./journalList"

const DataJournal = ():JSX.Element => {
    return (
        <>
        <SearchForm/>
        <JournalList/>
        </>
    )
}
export default DataJournal